
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/symbols",
      function () {
        return require("private-next-pages/symbols/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/symbols"])
      });
    }
  